(function () {

  // 🔁 Update button text (for dynamic content)
  function updateButtons() {
    const buttons = document.querySelectorAll('.fs-shopify-add-cart');

    buttons.forEach(btn => {
      if (btn.classList.contains('custom-shop-now')) return;

      btn.classList.add('custom-shop-now');
      btn.textContent = "Shop Now";
    });
  }

  // 🚀 Run initially
  document.addEventListener("DOMContentLoaded", updateButtons);

  // 👀 Watch for popup / dynamic injection
  const observer = new MutationObserver(() => {
    updateButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 🛑 Kill ALL default app behavior + redirect
  function handleClick(e) {
    const btn = e.target.closest('.fs-shopify-add-cart');
    if (!btn) return;

    // 🚫 Block everything from app
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // 🔗 Get product URL
    let productUrl = btn.getAttribute('data-product-url');

    if (productUrl) {
      if (!productUrl.startsWith('http')) {
        productUrl = 'https://' + productUrl;
      }

      // ✅ Redirect only
      window.location.href = productUrl;
    }
  }

  // ⚡ Use capture phase to override app
  ["click", "mousedown"].forEach(eventType => {
    document.addEventListener(eventType, handleClick, true);
  });

})();